import React from 'react';

import { CustomContainer as BaseContainer } from '../../../blockContainer';

import { ReaderBlock } from '../../Reader/core';
import { getContainerGridTemplateRows } from '../../../../utils/containerChildLayout';

const ContainerReader = ({ style, props, form_data, formCode, formClientWidth, unSubData, successMessage, ...rest })=> {
  const childrenIds = props?.childrenIds ?? [];
  const childHeightGrow = props?.childHeightGrow;
  return (
    <BaseContainer style={style} formClientWidth={formClientWidth} layoutStyle={{
      gridTemplateRows: getContainerGridTemplateRows(childrenIds, childHeightGrow),
    }}>
      {childrenIds.map((childId) => (
        <ReaderBlock key={childId} id={childId} formData={form_data} formCode={formCode} formClientWidth={formClientWidth} 
        unSubData={unSubData} successMessage={successMessage} {...rest}/>
      ))}
    </BaseContainer>
  );
}

export default ContainerReader

